import { render, staticRenderFns } from "./academicsList.vue?vue&type=template&id=42524726&scoped=true"
import script from "./academicsList.vue?vue&type=script&lang=js"
export * from "./academicsList.vue?vue&type=script&lang=js"
import style0 from "./academicsList.vue?vue&type=style&index=0&id=42524726&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42524726",
  null
  
)

export default component.exports